import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import AppEmptyResult from 'main/core/AppEmptyResult';
import AppTableContainer from 'main/core/AppTableContainer';
import PropTypes from 'prop-types';
import {useMemo} from 'react';
import TableHeader from './TableHeader';
import TableRows from './TableRows';

const TableList = ({
  widgetSpec = {},
  tableParams,
  rows = [],
  totalRows,
  checkedRows = [],
  setCheckedRows,
  onChangeCheckedRows,
  dataColumns = [],
  onRequestSort,
  isLoading,
  isError,
}) => {
  const {page, pageSize} = tableParams;

  const rowsToPrint = useMemo(() => {
    if (rows.length > pageSize) {
      const start = page * pageSize;
      return rows.slice(start, start + pageSize);
    }
    return rows;
  }, [rows, page, pageSize]);

  return (
    <AppTableContainer>
      {!isLoading && rowsToPrint.length > 0 ? (
        <Table size='small' stickyHeader className='table'>
          <TableHeader
            tableSpec={widgetSpec}
            tableParams={tableParams}
            checkedRows={checkedRows}
            setCheckedRows={setCheckedRows}
            onRequestSort={onRequestSort}
            dataColumns={dataColumns}
            rows={rows}
            totalRows={totalRows}
          />

          <TableBody>
            {rowsToPrint.map((row, i) => {
              const id = row[widgetSpec.idfieldname];
              return (
                <TableRows
                  dataRow={row}
                  key={`${id}-${i}`}
                  index={i}
                  tableSpec={widgetSpec}
                  checked={checkedRows.includes(id)}
                  onChangeCheckedRows={onChangeCheckedRows}
                  dataColumns={dataColumns}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <AppEmptyResult
          title={isError ? 'Something went wrong!' : undefined}
          description={isError ? 'Please try again later.' : undefined}
        />
      )}
    </AppTableContainer>
  );
};

TableList.propTypes = {
  widgetSpec: PropTypes.object,

  // The unified params object
  tableParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    sortOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
    sortColumn: PropTypes.string.isRequired,
    search: PropTypes.string,
  }).isRequired,

  rows: PropTypes.array,
  totalRows: PropTypes.number,
  checkedRows: PropTypes.array,
  setCheckedRows: PropTypes.func,
  onChangeCheckedRows: PropTypes.func,
  dataColumns: PropTypes.array,
  onRequestSort: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
};

export default TableList;
